import type { ComponentType } from 'react'
import { View } from 'react-native'
import type { LucideProps } from 'lucide-react-native'
import { colors } from '@chillout/core'
import { StampMotif } from './StampMotif'

export type StampState = 'filled' | 'preview' | 'removing' | 'empty'

interface StampCircleProps {
  state: StampState
  size?: number
  accessibilityLabel?: string
  icon?: ComponentType<LucideProps>
}

export function StampCircle({ state, size = 36, accessibilityLabel, icon: Icon }: StampCircleProps) {
  const motifSize = size * 0.5
  const isEmpty = state === 'empty'
  const isPreview = state === 'preview'
  const isRemoving = state === 'removing'

  const backgroundColor = isEmpty ? 'transparent'
    : isPreview ? colors.accent.surface
    : isRemoving ? colors.border
    : colors.stamp.filled
  const motifColor = isEmpty ? colors.stamp.emptyLight
    : isPreview ? colors.accent.DEFAULT
    : isRemoving ? colors.stamp.emptyLight
    : colors.text.inverse

  return (
    <View
      accessible={!!accessibilityLabel}
      accessibilityLabel={accessibilityLabel}
      style={{
        width: size,
        height: size,
        borderRadius: size / 2,
        backgroundColor,
        borderWidth: isEmpty ? 2 : 0,
        borderColor: isEmpty ? colors.stamp.emptyLight : undefined,
        borderStyle: isEmpty ? 'dashed' : undefined,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {Icon ? (
        <Icon size={motifSize} color={motifColor} strokeWidth={1.5} />
      ) : (
        <StampMotif size={motifSize} color={motifColor} />
      )}
    </View>
  )
}